import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabaseClient';
import { config } from '../lib/config';
import { demoStore } from '../features/demo/store';
import type { PostRow } from '../types/db';

/** Posts, die eine Verifikation brauchen (FLASH / PRÜFUNG / review). */
export const needsReview = (p: PostRow) =>
  p.flair === 'FLASH' ||
  p.flair === 'PRÜFUNG' ||
  p.flair === 'NEU' ||
  p.status === 'review' ||
  p.status === 'flagged';

export function useReviewQueue() {
  return useQuery({
    queryKey: ['posts', 'review-queue'],
    staleTime: 15000,
    queryFn: async (): Promise<PostRow[]> => {
      if (config.e2e) return demoStore.posts().filter(needsReview);
      const { data, error } = await supabase
        .from('posts')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(300);
      if (error) throw error;
      return (data ?? []).filter(needsReview);
    },
  });
}
